/**
 * usePageTitle Hook
 * 
 * Sets the document title for the current page.
 * 
 * @module hooks/usePageTitle
 */

import { useEffect } from 'react';

const BASE_TITLE = 'Hummingbird';

/**
 * Sets the document title with optional suffix.
 * 
 * @param title - The page title (will be formatted as "Title | Hummingbird")
 * 
 * @example
 * usePageTitle('Dashboard'); // Sets title to "Dashboard | Hummingbird"
 * usePageTitle(); // Sets title to "Hummingbird"
 */
export function usePageTitle(title?: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;

    // Restore previous title on unmount (optional, for SPA navigation)
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
